import { Component, Input } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';

@Component({
  selector: "app-response-modal",
  templateUrl: "./response-modal.component.html",
  styleUrls: ["./response-modal.component.scss"],
})
export class ResponseModalComponent {
  
  @Input() responses: any = null;
  numbers: number[] = Array.from({ length: 31 }, (_, i) => i + 1);

  constructor(
    public modalRef: MdbModalRef<ResponseModalComponent>
  ) {}

  setResponses(responses: any){
    if (responses.length > 0){
      this.responses = responses;
    }
  }
}